export const CONTACTS_SET_USER = "CONTACTS_SET_USER";
export const CONTACTS_UPDATE = "CONTACTS_UPDATE";
export const CONTACTS_CLEAR = "CONTACTS_CLEAR";
